import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { AppConfigService } from '@justonweb/core';
import { NotificationHandler } from '@justonweb/notification';
import { TestEnvironmentComponent } from '@justonweb/dialogs';
import { ActivatedRoute } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

export enum LoginType{
  Citizen = 'citizen',
  Lawyer = 'lawyer',
  Organisation = 'organisation',
  LawyerCard = 'lawyerCard',
  Staff = 'staff',
  Justice = 'justice'
}

export enum LoginUrlKeys{
  LoginUrlCitizenNl = "loginUrlCitizenNl",
  LoginUrlCitizenFr = "loginUrlCitizenFr",
  LoginUrlCitizenDe = "loginUrlCitizenDe",

  LoginUrlLawyerNl = "loginUrlLawyerNl",
  LoginUrlLawyerFr = "loginUrlLawyerFr",
  LoginUrlLawyerDe = "loginUrlLawyerDe",

  LoginUrlOrganisationNl = "loginUrlOrganisationNl",
  LoginUrlOrganisationFr = "loginUrlOrganisationFr",
  LoginUrlOrganisationDe = "loginUrlOrganisationDe",

  LoginUrlLawyerCardNl = "loginUrlLawyerCardNl",
  LoginUrlLawyerCardFr = "loginUrlLawyerCardFr",
  LoginUrlLawyerCardDe = "loginUrlLawyerCardDe",

  LoginUrlStaffNl = "loginUrlStaffNl",
  LoginUrlStaffFr = "loginUrlStaffFr",
  LoginUrlStaffDe = "loginUrlStaffDe",

  LoginUrlJusticeNl = "loginUrlJusticeNl",
  LoginUrlJusticeFr = "loginUrlJusticeFr",
  LoginUrlJusticeDe = "loginUrlJusticeDe",
}

@Component({
    selector: 'justonweb-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  LoginType = LoginType;

  constructor(
    private appConfigService: AppConfigService,
    private translationService: TranslocoService,
    private notificationHandler: NotificationHandler,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    const message = this.route.snapshot.queryParamMap.get('logoutMessage');
    //Check if we need to notify the user with a logoutMessage
    if (!!message) {
      this.translationService.events$
        .pipe(
            filter(event => event.type === 'translationLoadSuccess'),
            take(1)
        )
        .subscribe(_ => this.notificationHandler.handle('warning', '', this.translationService.translate(message)));
    }

    if (this.appConfigService.isTestEnvironment) {
      TestEnvironmentComponent.openDialog(this.dialog);
    }
  }

  navigateToLoginUrl(loginType: string) {
    const config = this.appConfigService.getConfig();
    const language = this.translationService.getActiveLang();

    let loginUrl = '';

      //Set the login url based on loginType and language

      //Citizen
      if(loginType === LoginType.Citizen){
        if(language === 'nl'){
          loginUrl = config[LoginUrlKeys.LoginUrlCitizenNl]
        }
        else if(language === 'fr'){
          loginUrl = config[LoginUrlKeys.LoginUrlCitizenFr]
        }
        else if(language === 'de'){
          loginUrl = config[LoginUrlKeys.LoginUrlCitizenDe]
        }
      }

      //Lawyer
      else if(loginType === LoginType.Lawyer){
        if(language === 'nl'){
          loginUrl = config[LoginUrlKeys.LoginUrlLawyerNl]
        }
        else if(language === 'fr'){
          loginUrl = config[LoginUrlKeys.LoginUrlLawyerFr]
        }
        else if(language === 'de'){
          loginUrl = config[LoginUrlKeys.LoginUrlLawyerDe]
        }
      }

      //LawyerCard
      else if(loginType === LoginType.LawyerCard){
        if(language === 'nl'){
          loginUrl = config[LoginUrlKeys.LoginUrlLawyerCardNl]
        }
        else if(language === 'fr'){
          loginUrl = config[LoginUrlKeys.LoginUrlLawyerCardFr]
        }
        else if(language === 'de'){
          loginUrl = config[LoginUrlKeys.LoginUrlLawyerCardDe]
        }
      }

      //Staff
      else if(loginType === LoginType.Staff){
        if(language === 'nl'){
          loginUrl = config[LoginUrlKeys.LoginUrlStaffNl]
        }
        else if(language === 'fr'){
          loginUrl = config[LoginUrlKeys.LoginUrlStaffFr]
        }
        else if(language === 'de'){
          loginUrl = config[LoginUrlKeys.LoginUrlStaffDe]
        }
      }

      //Organisation
      else if(loginType === LoginType.Organisation){
        if(language === 'nl'){
          loginUrl = config[LoginUrlKeys.LoginUrlOrganisationNl]
        }
        else if(language === 'fr'){
          loginUrl = config[LoginUrlKeys.LoginUrlOrganisationFr]
        }
        else if(language === 'de'){
          loginUrl = config[LoginUrlKeys.LoginUrlOrganisationDe]
        }
      }

      //Justice
      else if(loginType === LoginType.Justice){
        if(language === 'nl'){
          loginUrl = config[LoginUrlKeys.LoginUrlJusticeNl]
        }
        else if(language === 'fr'){
          loginUrl = config[LoginUrlKeys.LoginUrlJusticeFr]
        }
        else if(language === 'de'){
          loginUrl = config[LoginUrlKeys.LoginUrlJusticeDe]
        }
      }

    const connectionReset = this.route.snapshot.queryParamMap.get('connectionReset');
    if (connectionReset) {
      window.location.href = loginUrl + '&connectionReset=' + connectionReset;
    } else {
      window.location.href = loginUrl;
    }
  }

}
